import(/* webpackMode: "eager" */ "/codebuild/output/src3897186635/src/rellify-web/src/app/organizations/page.tsx");
